/**
 * Friendly, human-readable labels for a metadata field's `data_type`.
 *
 * The raw codes (`SELECT`, `MULTISELECT`, ...) are storage values; admins
 * editing validation rules need a plain word ("Select", "Multi-select") shown
 * next to each field so they don't have to bounce back to the metadata view to
 * recall what type a field is.
 */

const FIELD_TYPE_LABELS: Record<string, string> = {
  TEXT: 'Text',
  NUMBER: 'Number',
  DATE: 'Date',
  SELECT: 'Select',
  MULTISELECT: 'Multi-select',
  GPS: 'GPS',
  LIST: 'List',
};

/** Map a raw `data_type` code to its display label; unknown codes pass through. */
export function fieldTypeLabel(dataType: string | null | undefined): string {
  if (!dataType) {
    return 'Unknown type';
  }
  return FIELD_TYPE_LABELS[dataType] ?? dataType;
}
